import { Icon, IconType } from "@livingmap/core-ui-v2";
import classNames from "classnames";
import { FC } from "react";
import { LocationStatus } from "../LocationButton/LocationButton";
import styles from "./ListItemLocationButton.module.scss";

export enum COLOURS {
  BLUE = "blue",
  GREY = "grey",
}

interface Props {
  dataQA: string;
  className?: string;
  color?: COLOURS;
  title: string;
  status: LocationStatus;
  onClick?: () => void;
}

const ListItemLocationButton: FC<Props> = ({
  dataQA,
  className,
  title,
  color = COLOURS.GREY,
  status,
  onClick,
}) => {
  let iconType: IconType = "NearMeOutlineIcon";
  switch (status) {
    case LocationStatus.FOUND:
      iconType = "NearMeIcon";
      break;
    case LocationStatus.DISABLED:
      iconType = "NearMeDisabledOutlineIcon";
      break;
    case LocationStatus.OUTOFBOUNDS:
      iconType = "NearMeDisabledOutlineIcon";
      break;
    default:
      iconType = "NearMeOutlineIcon";
  }

  return (
    <div
      data-qa={dataQA}
      className={classNames(styles.container, className, styles[color])}
      onClick={onClick}
    >
      <div className={styles.iconContainer}>
        <Icon
          type={iconType}
          dataQA="icon"
          className={classNames(styles.icon, {
            [styles.found]: status === LocationStatus.FOUND,
            [styles.searching]: status === LocationStatus.SEARCHING,
            [styles[color]]: status === LocationStatus.FOUND,
          })}
          width={18}
          height={18}
        />
      </div>
      <div className={styles.content}>
        <div className={styles.title}>
          <span>{title}</span>
        </div>
      </div>
    </div>
  );
};

export default ListItemLocationButton;
